import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnInit, Renderer2, ViewChild} from '@angular/core';
import {NgForm, NgModel} from '@angular/forms';
import {firstNestedSymbolControl, TextControl} from '../../../models/uiArtefakt';
import {ValidationService} from '../../../services/validation.service';
import {UiUpdateService} from '../../../services/ui-update.service';
import {UIDarstellungsart} from '../../../models/uiDarstellungsart';
import {UIAusrichtung} from '../../../models/uiAusrichtung';
import {ShellConfigService} from '../../../services/shell-config.service';
import {AudisService, ISymbol, KeycloakLv1871Service, UiConfigService, VermittlerResponse} from '@lv1871/core';
import {normalizeVermittlernummer} from '../../../models/vermittlerdaten';
import {EventService} from '../../../services/event.service';
import {filter, map, switchMap, take, tap} from 'rxjs/operators';
import {Observable, of, ReplaySubject} from 'rxjs';
import {StageConfigService} from '../../../services/stage-config.service';

@Component({
    selector: 'lv-vermittlernummer',
    templateUrl: './vermittlernummer.component.html',
    styleUrls: ['./vermittlernummer.component.scss'],
    standalone: false
})
export class VermittlernummerComponent implements OnInit, AfterViewInit {

  @ViewChild(NgForm, {static: true})
  private _ngForm;
  @ViewChild('vmr', {static: true})
  private _vmr: NgModel;

  public isDisabled: boolean = false;
  public uiAusrichtung: UIAusrichtung;
  public nestedSymbol: ISymbol;
  public showInfotextCollapsable: boolean = false;
  public model: string;
  public vermittlernummerPruefung$: Observable<string>;
  public darfVermittlernameSehen: boolean;
  public autocomplete: string;

  private _uiArtefakt: TextControl;
  private _host: string;
  private _vermittlernummerPruefungSubject$ = new ReplaySubject<string>(1);

  constructor(private _keycloakService: KeycloakLv1871Service, private cd: ChangeDetectorRef, private _validationService: ValidationService,
              private _eventService: EventService,
              private _shellConfigService: ShellConfigService, private _audisService: AudisService,
              private _uiConfigService: UiConfigService, private _uiUpdateService: UiUpdateService,
              private _stageConfigService: StageConfigService,
              private _renderer: Renderer2, private _element: ElementRef) {
    this._host = this._uiConfigService.getAntragserfassungUrl();
    this.vermittlernummerPruefung$ = this._vermittlernummerPruefungSubject$.pipe(
        switchMap(vermittlernummer =>
            !!vermittlernummer ? this._audisService.getVermittler(this._host, vermittlernummer) : of(new VermittlerResponse())),
        map(resp => {
          if (!resp) {
            return 'Vermittlernummer nicht gefunden';
          } else {
            return !!resp.vermittlerName ? 'Vermittlername: ' + resp.vermittlerName : 'Vermittlernummer ungültig';
          }
        }));
  }

  get uiArtefakt(): TextControl {
    return this._uiArtefakt;
  }

  @Input() set uiArtefakt(uiArtefakt: TextControl) {
    this._uiArtefakt = uiArtefakt;
    this.isDisabled = this._uiArtefakt?.Darstellungsart === UIDarstellungsart.DISABLED;
  }

  public infotextCollapsableChange(event) {
    this.showInfotextCollapsable = event;
  }

  public ngOnInit(): void {
    this.darfVermittlernameSehen = this._keycloakService.hasRole('Antragsdatenerfassung');
    this.model = this.uiArtefakt.WertEingabe;
    this.uiAusrichtung = this._shellConfigService.getParameter().uiAusrichtung;
    this.autocomplete = this._stageConfigService.getInputAutocomplete();
    this.nestedSymbol = firstNestedSymbolControl(this.uiArtefakt.UIArtefakt);
    this._validationService.registerForm(this.uiArtefakt, this._ngForm);
    this._vmr.control.statusChanges.pipe(
        take(1),
        filter(status => status === 'VALID'),
        tap(_ => this._vermittlernummerPruefungSubject$.next(this.uiArtefakt.WertEingabe))).subscribe();
  }

  public ngAfterViewInit() {
    this.cd.detectChanges();
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
    if(!!this.uiArtefakt.ReferenzIdentifikator) {
      this._renderer.setAttribute(this._element.nativeElement, 'cypress-refId', this.uiArtefakt.ReferenzIdentifikator);
    }
  }

  public changeValue(value: any, isValid: boolean) {
    if (normalizeVermittlernummer(value) === normalizeVermittlernummer(this.uiArtefakt.WertEingabe)) {
      return;
    }
    if (!value) {
      this.uiArtefakt.WertEingabe = null;
      this._vermittlernummerPruefungSubject$.next(null);
      this._uiUpdateService.valueChangedSubject$.next(this.uiArtefakt);
      return;
    }
    if (isValid) {
      this.uiArtefakt.WertEingabe = normalizeVermittlernummer(value);
      this._vermittlernummerPruefungSubject$.next(this.uiArtefakt.WertEingabe);
      this._uiUpdateService.valueChangedSubject$.next(this.uiArtefakt);
    } else {
      this._vermittlernummerPruefungSubject$.next(null);
    }
  }

  onBlur() {
    if(!!this._uiArtefakt.ReferenzIdentifikator){
      this._eventService.refIdentTouchedOrDirty$.next(this._uiArtefakt.ReferenzIdentifikator);
    }
  }
}
